<template>
  <div data-sidebar="group-content" :class="cn('tw:w-full tw:text-sm', props.class)">
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
